"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const strings_1 = require("../../../../constants/strings");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const zustandStore_1 = require("../../../../zustandStore");
const peopleTable_1 = require("../../../organisms/createTeamModal/peopleTable");
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const submitForm = ({ setIsUserRoleAsideOpen, decoratedUser, currentSelectedUser, teamId, selectedRole, updateUserRole, setNotification, teamUsers, }) => {
    if (decoratedUser && !lodash_1.default.isEmpty(decoratedUser) && !lodash_1.default.isEmpty(currentSelectedUser)) {
        const currentTeamRole = (0, peopleTable_1.getUserRoleIdByTeamId)(currentSelectedUser?.roles, teamId);
        if (!currentTeamRole || lodash_1.default.isEmpty(selectedRole)) {
            return;
        }
        if (teamUsers.users.length === 1 && selectedRole.id === 'team_member') {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: strings_1.peopleTableStrings.ONLY_USER_WARNING_MESSAGE(currentSelectedUser.fullName),
                },
            ]);
            setIsUserRoleAsideOpen(false);
        }
        else if ((currentTeamRole === 'team_admin' || currentTeamRole === 'manager') &&
            decoratedUser.requesters &&
            decoratedUser.requesters.length > 0 &&
            selectedRole.id === 'team_member') {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: strings_1.peopleTableStrings.APPROVER_WARNING_MESSAGE(currentSelectedUser.fullName),
                },
            ]);
            setIsUserRoleAsideOpen(false);
        }
        else if (!lodash_1.default.isEmpty(currentSelectedUser?.roles) && selectedRole.id && selectedRole.id !== currentTeamRole) {
            updateUserRole.mutate({ userId: currentSelectedUser?.userId, selectedRoleId: selectedRole.id, teamId }, {
                onSettled: () => {
                    setIsUserRoleAsideOpen(false);
                },
            });
        }
    }
};
const SelectRoleAside = () => {
    const { setCurrentUserRoleAside, setIsUserRoleAsideOpen, setNotification } = (0, zustandStore_1.useZustand)();
    const { data: teamId } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: teamUsers } = (0, teamQuery_1.useGetTeamUsersQuery)({ teamId });
    const isUserRoleAsideOpen = (0, zustandStore_1.useZustand)(state => state.aside.userRole.isOpen);
    const curentUserRole = (0, zustandStore_1.useZustand)(state => state.aside.userRole.curentUserRole);
    const currentSelectedUser = (0, zustandStore_1.useZustand)(state => state.aside.userDetails.user);
    const roles = (0, zustandStore_1.useZustand)(state => state.role.roles);
    const { data: decoratedUser } = (0, react_query_1.useQuery)((0, teamQuery_1.getDecoratedUserQuery)({
        teamId,
        userId: currentSelectedUser ? currentSelectedUser?.userId : '',
    }));
    const updateUserRole = (0, rolesQuery_1.useUpdateUserRoleQuery)();
    const { refetch: refetchGetTeamRolesV2 } = (0, rolesQuery_1.useGetTeamRolesV2Query)(curentUserRole, false);
    (0, react_1.useEffect)(() => {
        void refetchGetTeamRolesV2();
    }, [refetchGetTeamRolesV2]);
    const isChecked = (option) => {
        return curentUserRole.id === option.id;
    };
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: 'selectAside', title: strings_1.peopleTableStrings.ASIDE_TITLE, open: isUserRoleAsideOpen, onClose: () => setIsUserRoleAsideOpen(false), footerButtons: null, children: (0, jsx_runtime_1.jsx)("form", { style: {
                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? {
                        padding: 0,
                    }
                    : {}),
            }, children: (0, jsx_runtime_1.jsx)(material_1.MenuList, { children: roles && Object.keys(roles).length > 0
                    ? Object.keys(roles).map(optionKey => ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, { className: isChecked(roles[optionKey] || '') ? 'ts-checked' : '', disabled: roles[optionKey].disabled, onClick: () => {
                            setCurrentUserRoleAside(roles[optionKey]);
                            submitForm({
                                setIsUserRoleAsideOpen,
                                decoratedUser,
                                currentSelectedUser,
                                teamId: teamId && teamId.length > 0 ? teamId?.[0] : '',
                                selectedRole: roles[optionKey],
                                updateUserRole,
                                setNotification,
                                teamUsers,
                            });
                        }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { style: {
                                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP && isChecked(roles[optionKey])
                                        ? {
                                            color: 'white',
                                        }
                                        : {}),
                                }, children: roles[optionKey].label }), (0, jsx_runtime_1.jsx)(material_1.Typography, { style: { marginLeft: 'auto' }, children: isChecked(roles[optionKey]) ? ((0, jsx_runtime_1.jsx)(Check_1.default, { style: {
                                        ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                            ? {
                                                filter: 'invert(1)',
                                            }
                                            : {}),
                                    } })) : ('') })] }, optionKey)))
                    : '' }) }) }));
};
exports.default = SelectRoleAside;
